<template>
  <div class="flex flex-col md:flex-row gap-3 lg:gap-4">
    <PaperCard
      v-for="option in paymentFrequencyOptions"
      :key="option.value"
      class="cursor-pointer w-full overflow-hidden !p-0 border-2"
      :class="
        is_compounded === option.value ? 'border-radio-checkbox-outline' : 'border-transparent'
      "
      :has_header="false"
      @click="purchaseFlowStore.current_investment.is_compounded = option.value"
    >
      <template #body>
        <div class="relative flex items-start md:items-center min-h-[140px] p-6">
          <div class="max-w-[60%]">
            <p class="text-[20px] md:text-[28px] font-medium text-strongest">
              {{ option.text }}
            </p>
            <p class="text-sm font-inter text-strong font-medium mt-1">
              {{ option.subtext }}
            </p>
          </div>
          <img
            :src="option.value ? compoundedLogo : simpleLogo"
            :alt="option.text"
            class="absolute top-2 -right-[40px] h-[180px] w-[180px] object-contain"
          />
        </div>
      </template>
    </PaperCard>
  </div>
</template>

<script setup>
import { computed } from "vue";

import { usePurchaseFlowStore, useUIStore } from "@/stores";
import { PaperCard } from "@/components";

import compoundedLogoGold from "@/assets/images/compounding_gold.png";
import compoundedLogoBlue from "@/assets/images/compounding_blue.png";
import simpleLogoGold from "@/assets/images/monthly_payments_gold.png";
import simpleLogoBlue from "@/assets/images/monthly_payments_blue.png";

const purchaseFlowStore = usePurchaseFlowStore();
const UIStore = useUIStore();

const compoundedLogo = computed(() => {
  return UIStore.is_dark_mode ? compoundedLogoBlue : compoundedLogoGold;
});

const simpleLogo = computed(() => {
  return UIStore.is_dark_mode ? simpleLogoBlue : simpleLogoGold;
});

const is_compounded = computed(() => {
  return purchaseFlowStore.current_investment.is_compounded;
});

const is_short_term = computed(() => {
  return purchaseFlowStore.selected_offering?.is_short_term ?? false;
});

const paymentFrequencyOptions = computed(() => [
  {
    text: "Interest Paid Monthly",
    subtext: "I want interest paid out monthly",
    value: false,
  },
  {
    text: is_short_term.value ? "Compounding" : "Compounded Monthly",
    subtext: is_short_term.value
      ? "I want my interest compounded daily, with both principal and interest paid out at maturity or put date"
      : "I want interest and principal paid at maturity",
    value: true,
  },
]);

defineExpose({
  async validate() {
    return { proceed: true };
  },
  afterContinue: async () => await purchaseFlowStore.saveInvestmentProgress(),
});
</script>
